import axios from "axios"
import qs from "qs"
const cancelToken = {
	addPending:(pending, config) => {
		let url = []
		if(config.url==='/api/Member/List'||config.url==='/api/Pet/List'){
			url = [
				config.method,
				config.url,
			].join('&')
		}else if(config.url==='/api/Activity/Consume/Goods'||config.url==='/api/Activity/Consume/Product'||config.url==='/api/Activity/Consume/GoodsGroup'||config.url==='https://account1.huashengchongwu.com/api/media/pos80_print'){
			console.log(url)
		}else{
			url = [
				config.method,
				config.url,
				qs.stringify(config.params),
				qs.stringify(config.data)
			].join('&')
		}
		config.cancelToken = config.cancelToken || new axios.CancelToken(cancel => {
			if (!pending.has(url)) {
				pending.set(url, cancel)
			}
		})
	},
	removePending:(pending, config) => {
		let url = []
		if(config.url==='/api/Member/List'||config.url==='/api/Pet/List'){
			url = [
				config.method,
				config.url,
			].join('&')
		}else{
			url = [
				config.method,
				config.url,
				qs.stringify(config.params),
				qs.stringify(config.data)
			].join('&')
		}
		if (pending.has(url)) {
			const cancel = pending.get(url)
			cancel(url)
			pending.delete(url)
		}
	},
	clearPending:(pending) => {
		for (const [url, cancel] of pending) {
			cancel(url)
		}
		pending.clear()
	}
}

export default cancelToken;